<template>
  <div
    class="wt2-produced-popup"
    @mousemove="onProducedMove"
    @mouseleave="onProducedLeave"
  >
    <wt-masthead-like-header
      v-if="videoData"
      v-show="getMastHeadVisibleStatus"
      @toggle="toggleActionPanel"
      @pause="pauseVideo"
      @close="closeModal"
      :info-active="getActionPanelOpenStatus"
      :title="videoData.title"
      :type="getMastHeadCurrentType"
      :analytics="analytics"
      @enabledPlay="canPlay = true"
      @disabledPlay="canPlay = false"
    />

    <produced-content
      v-if="videoData"
      :timeout-control-time="timeoutControlTime"
      :video="videoData"
      :modal="true"
      :canPlay="canPlay"
    />

    <div v-if="loading" class="wt-dashboard-loader">
      <div class="wt-loader" />
    </div>
  </div>
</template>

<script>
import app from 'app';
import ProducedContent from 'v/Produced/ProducedContent.vue';
import PopupActionMixin from 'mixins/PopupAction.vue';
import '#/store/module/popupAction.vuex';

export default {
  mixins: [PopupActionMixin],

  components: {
    ProducedContent,
  },

  name: 'ProducedPopup',

  props: {
    video: {
      type: Object,
      required: false,
      default: null,
    },

    videoId: {
      type: String,
      required: false,
      default: null,
    },

    closeModal: {
      type: Function,
    },
  },

  data() {
    return {
      loading: false,
      videoPreview: null,
      canPlay: true,
    };
  },

  computed: {
    videoData() {
      return this.video || this.videoPreview;
    },
  },

  methods: {
    markAsRead() {
      if (!this.videoData.read) {
        app.api.producedStories.view({ id: this.videoData.id }).then(() => {
          this.videoData.read = true;
        });
      }
    },

    analytics({ action, params }) {
      app.analytics('produce:' + action, params);
    },

    pauseVideo() {
      if (this.$store.state.playing) {
        this.$store.commit('toggleActionPanel');
      }
    },
  },

  created() {
    if (this.video) {
      this.markAsRead();
    } else if (this.videoId) {
      this.loading = true;

      app.api.producedStoryPreviews
        .get(this.videoId)
        .then(
          (res) => {
            this.videoPreview = res;
            this.markAsRead();
          },
          (error) => {
            app.dialog.serverError(error).then(() => {
              app.navigateToDashboard({ replace: true });
            });
          }
        )
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>
